/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { LacTotalsResponseRowPaginatorResponse } from '../models/lac-totals-response-row-paginator-response';
import { postFeV1LacTotals$Json } from '../fn/lac-totals/post-fe-v-1-lac-totals-json';
import { PostFeV1LacTotals$Json$Params } from '../fn/lac-totals/post-fe-v-1-lac-totals-json';
import { postFeV1LacTotals$Plain } from '../fn/lac-totals/post-fe-v-1-lac-totals-plain';
import { PostFeV1LacTotals$Plain$Params } from '../fn/lac-totals/post-fe-v-1-lac-totals-plain';
import { postFeV1LacTotalsExport$Json } from '../fn/lac-totals/post-fe-v-1-lac-totals-export-json';
import { PostFeV1LacTotalsExport$Json$Params } from '../fn/lac-totals/post-fe-v-1-lac-totals-export-json';
import { postFeV1LacTotalsExport$Plain } from '../fn/lac-totals/post-fe-v-1-lac-totals-export-plain';
import { PostFeV1LacTotalsExport$Plain$Params } from '../fn/lac-totals/post-fe-v-1-lac-totals-export-plain';

@Injectable({ providedIn: 'root' })
export class LacTotalsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postFeV1LacTotals()` */
  static readonly PostFeV1LacTotalsPath = '/v1/lac-totals';

  /**
   * Search LAC totals (DETAIL or TOTAL mode) with date range and optional filters.
   *
   * Search LAC totals (DETAIL or TOTAL mode) with date range and optional filters.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1LacTotals$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacTotals$Plain$Response(params?: PostFeV1LacTotals$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<LacTotalsResponseRowPaginatorResponse>> {
    return postFeV1LacTotals$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Search LAC totals (DETAIL or TOTAL mode) with date range and optional filters.
   *
   * Search LAC totals (DETAIL or TOTAL mode) with date range and optional filters.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1LacTotals$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacTotals$Plain(params?: PostFeV1LacTotals$Plain$Params, context?: HttpContext): Observable<LacTotalsResponseRowPaginatorResponse> {
    return this.postFeV1LacTotals$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<LacTotalsResponseRowPaginatorResponse>): LacTotalsResponseRowPaginatorResponse => r.body)
    );
  }

  /**
   * Search LAC totals (DETAIL or TOTAL mode) with date range and optional filters.
   *
   * Search LAC totals (DETAIL or TOTAL mode) with date range and optional filters.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1LacTotals$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacTotals$Json$Response(params?: PostFeV1LacTotals$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<LacTotalsResponseRowPaginatorResponse>> {
    return postFeV1LacTotals$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search LAC totals (DETAIL or TOTAL mode) with date range and optional filters.
   *
   * Search LAC totals (DETAIL or TOTAL mode) with date range and optional filters.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1LacTotals$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacTotals$Json(params?: PostFeV1LacTotals$Json$Params, context?: HttpContext): Observable<LacTotalsResponseRowPaginatorResponse> {
    return this.postFeV1LacTotals$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<LacTotalsResponseRowPaginatorResponse>): LacTotalsResponseRowPaginatorResponse => r.body)
    );
  }

  /** Path part for operation `postFeV1LacTotalsExport()` */
  static readonly PostFeV1LacTotalsExportPath = '/v1/lac-totals/export';

  /**
   * Export all LAC totals matching the filter criteria (ignores pagination).
   *
   * Export all LAC totals matching the filter criteria (ignores pagination).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1LacTotalsExport$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacTotalsExport$Plain$Response(params?: PostFeV1LacTotalsExport$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postFeV1LacTotalsExport$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Export all LAC totals matching the filter criteria (ignores pagination).
   *
   * Export all LAC totals matching the filter criteria (ignores pagination).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1LacTotalsExport$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacTotalsExport$Plain(params?: PostFeV1LacTotalsExport$Plain$Params, context?: HttpContext): Observable<Blob> {
    return this.postFeV1LacTotalsExport$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * Export all LAC totals matching the filter criteria (ignores pagination).
   *
   * Export all LAC totals matching the filter criteria (ignores pagination).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1LacTotalsExport$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacTotalsExport$Json$Response(params?: PostFeV1LacTotalsExport$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postFeV1LacTotalsExport$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Export all LAC totals matching the filter criteria (ignores pagination).
   *
   * Export all LAC totals matching the filter criteria (ignores pagination).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1LacTotalsExport$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacTotalsExport$Json(params?: PostFeV1LacTotalsExport$Json$Params, context?: HttpContext): Observable<Blob> {
    return this.postFeV1LacTotalsExport$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
